__turbopack_context__.v({
  "closeButton": "kopE4a_closeButton",
  "content": "kopE4a_content",
  "description": "kopE4a_description",
  "image": "kopE4a_image",
  "marketingPopoverUnfold": "kopE4a_marketingPopoverUnfold",
  "popover": "kopE4a_popover",
});
